import { SET_ENDORSEMENT_TO_LOST } from '../../constants/actions/policy';

export function setEndorsementToLost(payload) {
    return {
        type: SET_ENDORSEMENT_TO_LOST,
        payload,
    };
}
